import { Component, forwardRef, Input, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'fspro-code-input',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CodeInputComponent),
      multi: true
    }
  ],
  templateUrl: './code-input.component.html',
  styleUrl: './code-input.component.scss',
  standalone: false
})
export class CodeInputComponent implements ControlValueAccessor {
  @Input() set length(length: number) {
    this._length = length;
    this._otpArray.clear();
    for (let i = 0; i < this._length; i++) {
      this._otpArray.push(this._fb.control('', [Validators.required, Validators.pattern(/^\d$/)]));
    }

    this._otpArray.valueChanges.subscribe(() => {
      this.onChange(this.fullCode);
    })
  }

  private _length: number | null = null;

  private _otpArray = this._fb.array([]);
  private onChange = (value: string) => {};
  private onTouched = () => {};
  private isDisabled = false;

  get controls() {
    return this._otpArray.controls;
  }

  get fullCode() {
    return this._otpArray.value.join('');
  }

  constructor(private _fb: FormBuilder) {
  }

  writeValue(value: string): void {
    if (value && value.length === this.length) {
      value.split('').forEach((char, i) => {
        this._otpArray.at(i).setValue(char);
      });
    } else {
      this._otpArray.reset();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this._otpArray.controls.forEach(control =>
      isDisabled ? control.disable() : control.enable()
    );
  }

  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') || '';
    const digits = pasted.replace(/\D/g, '').slice(0, this.length).split('');
    digits.forEach((digit, index) => {
      if (this._otpArray.at(index)) {
        this._otpArray.at(index)?.setValue(digit);
      }
    });
    setTimeout(() => {
      document.getElementById(`otp-${digits.length - 1}`)?.focus();
    });
  }

  onInput(e: Event, index: number) {
    const input = e.target as HTMLInputElement;
    const value = input.value;

    if (/^\d$/.test(value)) {
      this._otpArray.at(index)?.setValue(value);
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    } else {
      this._otpArray.at(index)?.setValue(value);
    }
  }

  onKeyDown(e: KeyboardEvent, index: number) {
    if (e.key === 'Backspace' && !this._otpArray.at(index)?.value && index > 0) {
      const prev = document.getElementById(`otp-${index - 1}`);
      prev?.focus();
    }
    if (e.key === 'ArrowLeft') {
      const prev = document.getElementById(`otp-${index - 1}`);
      prev?.focus();
    }
    if (e.key === 'ArrowRight') {
      const next = document.getElementById(`otp-${index + 1}`);
      next?.focus();
    }
  }
}
